import BookingForm from './BookingForm';

function BookingPage() {
    return (
        <>
       <BookingForm />
        </>
      );
    }

export default BookingPage;